import { useQuery } from '@hooks/reactQuery';

import { getOrganisationTypes } from '@api/common';

import { nameTitleToOptionFormatted } from '@utils/formatter';

import { TNameTitle } from '@interfaces/common/common';

import { refetchOptions } from '@constants/common';
import { ORGANISATION_TYPES } from '@constants/queryKeys';

export interface IOrganisationTypesResult {
	isLoadingOrganisationTypes: boolean;
	organisationTypes: TNameTitle[];
	optionsOrganizationTypes: TNameTitle[];
}

export const useQueryOrganisationTypes = (): IOrganisationTypesResult => {
	const {
		data: organisationTypes,
		isLoading: isLoadingOrganisationTypes,
		isFetching: isFetchingOrganisationTypes,
	} = useQuery<TNameTitle[]>({
			queryKey: [ORGANISATION_TYPES],
			queryFn: getOrganisationTypes,
			...refetchOptions,
		},
	);

	return {
		isLoadingOrganisationTypes: isLoadingOrganisationTypes || isFetchingOrganisationTypes,
		organisationTypes: organisationTypes || [],
		optionsOrganizationTypes: nameTitleToOptionFormatted(organisationTypes || []),
	};
};
